import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a5d39b06 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _9a0fd396 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _4c98ff50 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _d7aa4274 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _98efc934 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _9f10e960 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _2927380e = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _8305352e = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _a3fd319c = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _7a1000d3 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _9c19f932 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _deb45fee = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _315ca9e2 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _7fda5566 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1cb0db5e = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _5b228bc9 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _739e0470 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _3c51d8a6 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _7f0f0a16 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _7c886b56 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _dc132160 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _63d1558c = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _2b603d40 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _18822da6 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _37871ab3 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _5c29af5c = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _e5e421d8 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _eff70ea4 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _63ac7a8c = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _2739a9dc = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _7f5abfda = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _42eccecc = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _93d91322 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _8e8098b2 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _9d0040ae = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _b497d6ca = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _2eb34af6 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _c9e3f370 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _68ce2c76 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _443b5cba = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _7848f2ba = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _f4290e74 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _11ca0f39 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _34311414 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _50827517 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0728233a = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _2e616c0d = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _2107c2a7 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _5c2b346f = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _a2df3c36 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _e2a2b9a8 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _5914d218 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _73c1c12a = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _2db73c46 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _019761e0 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _0ba2a416 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _a49d5564 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _3b4e4dd1 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _3f1e8234 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _39caba42 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _1c02fdc3 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _ebd662d4 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _039a4897 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _002473cf = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _6d38da44 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _4098b025 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _6855b8c0 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _46b6937c = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _fddc8164 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _be78e3cc = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _3968b38f = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _33437702 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _8016ceda = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _cece6d7e = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _07b61ed7 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _6b6b7e9e = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _a5d39b06,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _9a0fd396,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _4c98ff50,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _d7aa4274,
    name: "calendar"
  }, {
    path: "/customer",
    component: _98efc934,
    name: "customer"
  }, {
    path: "/details",
    component: _9f10e960,
    name: "details"
  }, {
    path: "/goals",
    component: _2927380e,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _8305352e,
    name: "maisoku"
  }, {
    path: "/media",
    component: _a3fd319c,
    name: "media"
  }, {
    path: "/privacy",
    component: _7a1000d3,
    name: "privacy"
  }, {
    path: "/project",
    component: _9c19f932,
    name: "project"
  }, {
    path: "/response",
    component: _deb45fee,
    name: "response"
  }, {
    path: "/sale",
    component: _315ca9e2,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _7fda5566,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1cb0db5e,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _5b228bc9,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _739e0470,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _3c51d8a6,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _7f0f0a16,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _7c886b56,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _dc132160,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _63d1558c,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _2b603d40,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _18822da6,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _37871ab3,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _5c29af5c,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _e5e421d8,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _eff70ea4,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _63ac7a8c,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _2739a9dc,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _7f5abfda,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _42eccecc,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _93d91322,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _8e8098b2,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _9d0040ae,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _b497d6ca,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _2eb34af6,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _c9e3f370,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _68ce2c76,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _443b5cba,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _7848f2ba,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _f4290e74,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _11ca0f39,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _34311414,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _50827517,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0728233a,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _2e616c0d,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _2107c2a7,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _5c2b346f,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _a2df3c36,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _e2a2b9a8,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _5914d218,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _73c1c12a,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _2db73c46,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _019761e0,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _0ba2a416,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _a49d5564,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _3b4e4dd1,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _3f1e8234,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _39caba42,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _1c02fdc3,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _ebd662d4,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _039a4897,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _002473cf,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _6d38da44,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _4098b025,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _6855b8c0,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _46b6937c,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _fddc8164,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _be78e3cc,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _3968b38f,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _33437702,
    name: "property-property",
    children: [{
      path: "contact",
      component: _8016ceda,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _cece6d7e,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _07b61ed7,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _6b6b7e9e,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
